export const Stages = {
  ValleyStage: {
    helpSteps: [
      {
        src: "/evaluation.svg",
        title: ["Deep Dive", " Evaluation"],
      },
      {
        src: "/mvp.svg",
        title: ["Lean MVP", " Creation"],
      },
      {
        src: "/pivot.svg",
        title: ["Pivot", " Support"],
      },
      {
        src: "/presentation.svg",
        title: ["Pitch Deck", " Creation"],
      },
      {
        src: "/problem-solving.svg",
        title: ["Problem Solution", " Fit"],
      },
      {
        src: "/software.svg",
        title: ["Outsource", " Engineering"],
      },
    ],
    valleyStage: [
      {
        title: "Deep Dive Evaluation",
        desc: [
          "Unearth critical insights to understand your startup's ",
          "strengths, weaknesses, and market opportunities.",
        ],
      },
      {
        title: "Lean MVP Creation",
        desc: [
          "Rapidly build a Minimum Viable Product to test and validate ",
          "your idea in real-world scenarios.",
        ],
      },
      {
        title: "Pivot Support",
        desc: [
          "Strategically guide your startup through necessary pivots to ",
          "stay aligned with market demands.",
        ],
      },
      {
        title: "Pitch Deck Creation",
        desc: [
          "Craft a compelling, investor-ready pitch deck that captures ",
          "your vision and potential.",
        ],
      },
      {
        title: "Problem-Solution Fit Analysis",
        desc: [
          "Ensure your product effectively addresses market needs with ",
          "detailed fit analysis.",
        ],
      },
      {
        title: "Outsourced Product Engineering",
        desc: [
          "Access expert engineering services to build and scale your ",
          "product efficiently.",
        ],
      },
    ],
  },
  IdeaStage: {
    helpSteps: [
      {
        src: "/shuttle.svg",
        title: ["Startup", " Evaluation"],
      },
      {
        src: "/business.svg",
        title: ["Idea", " Validation"],
      },
      {
        src: "/idea.svg",
        title: ["Ideation", " Worshop"],
      },
      {
        src: "/mvp-idea.svg",
        title: ["Lean", " MVP"],
      },
      {
        src: "/branding.svg",
        title: ["Branding", " "],
      },
      {
        src: "/digital-marketing.svg",
        title: ["Digital", " Marketing"],
      },
    ],
    ideaStage: [
      {
        title: "Idea Validation",
        desc: ["Ensure your idea addresses a real market need."],
      },
      {
        title: "Market Research",
        desc: ["Understand your audience, competitors, and trends."],
      },
      {
        title: "Minimum Viable Brand (MVB)",
        desc: ["Create a visual identity that resonates."],
      },
      {
        title: "Planning for Execution",
        desc: ["Develop a clear roadmap for the next stages."],
      },
    ],
  },
  GrowthStage: {
    helpSteps: [
      {
        src: "/workflow.svg",
        title: ["Business", "Automation"],
      },
      {
        src: "/automation.svg",
        title: ["Sales", "Automation"],
      },
      {
        src: "/support.svg",
        title: ["Staffing", "Support"],
      },
      {
        src: "/promotion.svg",
        title: ["Recurring", "Revenue Strategies"],
      },
      {
        src: "/coding-cloud.svg",
        title: ["Paid Premium", "Bootcamps"],
      },
      {
        src: "/product.svg",
        title: ["Product Creation", "& Scaling"],
      },
    ],
    growthStage: [
      {
        title: "Business Automation",
        desc: [
          "Streamline operations with smart automation for efficiency and",
          "scalability.",
        ],
      },
      {
        title: "Sales Automation",
        desc: [
          "Boost revenue with automated, data-driven sales workflows",
          "that convert leads effortlessly.",
        ],
      },
      {
        title: "Staffing Support",
        desc: [
          "Build a strong team with tailored staffing solutions to meet",
          "your startup’s unique needs.",
        ],
      },
      {
        title: "Recurring Revenue Strategies",
        desc: [
          "Design sustainable revenue models that ensure consistent",
          "income.",
        ],
      },
      {
        title: "Paid Premium Bootcamps",
        desc: [
          "Deliver high-value learning experiences through premium,",
          "targeted bootcamps.",
        ],
      },
      {
        title: "Product Creation and Scaling",
        desc: [
          "Transform ideas into market-ready products and scale them",
          "for maximum impact.",
        ],
      },
    ],
  },
};

